export function toImageSrc(image: string): string {
  return image.startsWith('data:') || image.startsWith('http') ? image : `data:image/jpeg;base64,${image}`;
}

export function toBase64Payload(image: string): string {
  return image.replace(/^data:[^;,]*;base64,/i, '');
}
